// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"new-220w-solar-panel_productcontent__6T7K4"};